// src/utils/calcPrice.js
import { RATES } from "./rates";

const n = (v) => Number(v) || 0;
const round = (v) => Math.round((Number(v) || 0) * 100) / 100;

export default function calcPrice(form = {}, rates = RATES) {
  const liveMilesIn     = n(form.liveMiles);
  const dhField         = form.deadheadMiles; 
  const waitMinutesIn   = n(form.waitMinutes);
  const holdoverNights  = n(form.holdoverNights);
  const dedicatedHours  = n(form.dedicatedHours);
  const weightLbs       = n(form.weight);
  const afterHoursFlag  = !!form.afterHours;

  const billableLive = Math.max(0, liveMilesIn - (rates.mileageFreeMiles ?? 0));
  const rawDeadhead = (dhField === "auto" || dhField === undefined) ? 0 : n(dhField);
  const billableDeadhead = Math.max(0, rawDeadhead - (rates.deadheadFreeMiles ?? 0));

  const base      = round(rates.base ?? 0);
  const mileage   = round(billableLive * (rates.perMile ?? 0));
  const deadhead  = round(billableDeadhead * (rates.deadheadPerMile ?? rates.perMile ?? 0));

  const overBy    = Math.max(0, weightLbs - (rates.weightThreshold ?? 50));
  const weight    = round(overBy * (rates.weightPerLbOver ?? 0.20));

  const billableWaitMin = Math.max(0, waitMinutesIn - (rates.waitGraceMinutes ?? 15));
  const wait      = round(billableWaitMin * (rates.waitPerMinute ?? 0.67));

  const holdover  = round(holdoverNights * (rates.holdoverPerNight ?? 50.0));
  const dedicated = round(dedicatedHours * (rates.dedicatedPerHour ?? 71.5));

  const fuelPct   = rates.fuelPct ?? 0.1;
  const fuel      = round((base + mileage) * fuelPct);

  const afterHours = afterHoursFlag ? round(rates.afterHoursFlat ?? 100.0) : 0;

  const normalTotal = round(
    base + mileage + deadhead + weight + wait + holdover + dedicated + afterHours + fuel
  );

  if (!!form.useContract && n(form.contractPrice) > 0) {
    return {
      base: 0, mileage: 0, deadhead: 0, weight: 0, wait: 0, holdover: 0, dedicated: 0, afterHours: 0, fuel: 0,
      total: round(form.contractPrice),
      _contractApplied: true,
    };
  }

  return {
    base, mileage, deadhead, weight, wait, holdover, dedicated, afterHours, fuel,
    total: normalTotal,
    _contractApplied: false,
  };
}







